import React from 'react';
import {Select, AutoComplete, Tree} from 'antd';
import {connect} from 'react-redux';
import AjaxAction from '../../actions/AjaxAction.js';
import Info from '../Detail/Info';

import func from '../../util/func';
import ajaxUtil from '../../util/ajax';

const {TreeNode} = Tree;
const {DOMAIN_CURRENT, ajaxv2, ajax} = ajaxUtil;

const Option = Select.Option;

class ActivitySelect extends React.Component {

  constructor(props) {
      super(props);

      this.state = {
          list:null,
          tree:null,
          orderid:null,
      };

      this.debounceFetch = func.debounce(this.fetch, 500, false);
  }

  componentDidMount() {
    let {value, orderid} = this.props;
    // if(orderid) {
      if(orderid) {
        this.setState({
          orderid,
        });
        this.fetch(orderid, true);
      }
    // }
  }

  fetch = (val, justId)=>{
    let {value, orderid} = this.props;

      ajax({
        url:"/api/order",
        data:{
          key:JSON.stringify(justId ? {
            id:val
          } : {
            OR:{
              'name[~]':val,
              'id[~]':val,
              'fxiaoname[~]':val
            }
          }),
          sort:'-id',
          page:1,
          pagesize:10
        }
      }).then(res=>{
        if(res && res.data && res.data.length) {
          this.setState({
            list:res.data.map(it=>{
              return {
                key:it.id,
                name:it.name
              }
            })
          }, ()=>{
            if(value && orderid) {
              this.handleSelect(orderid);
            }
          });
        }
      })
  }

  renderOptions = ()=>{
      let {list} = this.state;
      return (list||[]).map(it=>{
          return <Option key={it.key}>{it.name}</Option>;
      });
  }

  handleSelect = (e)=>{
    ajax({
      url:"/api/gallery/searchv2",
      data:{
        orderid:e
      }
    }).then(res=>{
      this.setState({
        tree:res,
        orderid:e
      });
    })
  }

  handleChange = (e)=>{
      this.debounceFetch(e);
  }

  formatTree = (list)=>{
    let findLeaf = (item)=>{
      let leaf = list.filter(it=>it.parent == item.id);
      if(leaf && leaf.length) {
        item.children = leaf;
        item.children.forEach(it=>findLeaf(it));
      }
    }

    let result = null;
    let root = list.find(it=>it.parent * 1 === 0);
    if(root) {
      result = [root];
      findLeaf(result[0]);
    }

    return result;
  }

  renderTreeNodes = (list)=>{
    if(list && list.length) {
      return list.map(it=>{
        return <TreeNode title={<span>{it.name}<span style={{fontSize:12}}>{it.id * 1 > 1000000 ? '(新版)' : '(老版)'}</span></span>} key={it.id}>
          {this.props.disableTreeNode ? null : this.renderTreeNodes(it.children)}
        </TreeNode>
      })
    }
    return null;
  }

  setTarget = (e)=>{
    let value = e[0];

    if(this.props.onChange) {
      if(this.props.single) {
        this.props.onChange(value);
      }else {
        this.props.onChange(e);
      }
    }
  }

  render() {
      let {list, tree} = this.state;

      return <React.Fragment>
        <AutoComplete
            dataSource={list}
            style={{ width: '100%' }}
            onSelect={this.handleSelect}
            onSearch={this.handleChange}
            placeholder="请输入订单ID或订单活动名称"
        >{this.renderOptions()}</AutoComplete>
        {tree ? <Tree onSelect={this.setTarget} selectedKeys={this.props.single ? [this.props.value] : this.props.value} defaultExpandAll={true}>
          {this.renderTreeNodes(tree)}
        </Tree> : null}
      </React.Fragment>;
  }
}

export default connect((state) => ({
}))(ActivitySelect);



// WEBPACK FOOTER //
// ./src/components/Select/ActivitySelect.js